import { type FC, useCallback } from 'react'

import { ExclamationIcon } from '@/assets/icons/icon-exclamation.tsx'
import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'

interface Props {
  open: boolean
  loading: boolean
  onClose: () => void
  onStart: () => void
}

export const StartOfWarningDialog: FC<Props> = ({
  open,
  onClose,
  onStart,
  loading,
}) => {
  const handleStart = useCallback(() => {
    onStart()
    onClose()
  }, [onClose, onStart])

  return (
    <Dialog show={open}>
      <Dialog.Header>
        <ExclamationIcon className="mx-auto" />
        <Dialog.Title>Warning!</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description className="mt-1.5 block text-center">
        Starting OnlyFans this way could potentially cause issues because this
        browser method is outdated. We recommend launching the profile through
        the Creator Sidebar.
      </Dialog.Description>

      <Dialog.Footer className="flex gap-2">
        <Button
          isLoading={loading}
          className="flex-1"
          variant="outline"
          onClick={handleStart}
        >
          Start Anyway
        </Button>
        <Button
          className="flex-1"
          onClick={onClose}
        >
          Cancel
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
